import { traefik } from "@/http";

class LoginService {
  async logIn(token) {
    const response = await traefik.get("/login", {
      headers: { Authorization: token },
    });
    if (response.data) {
      localStorage.setItem("token", token);
    }
    return response;
  }
}
export default new LoginService();
